export function broadcastMatchStarting(_matchId: string, _opponent: string, _kickoffUtc: string): void {}
export function broadcastScoreUpdated(_matchId: string, _home: number, _away: number, _minute: number | null): void {}
export function broadcastFanReaction(_matchId: string | null, _kind: 'take' | 'gauge' | 'prediction'): void {}

/**
 * Safe-edge plumbing. Standalone/PWA gets env(safe-area-inset-*) via CSS;
 * inside the COYG container the host posts its gesture geometry instead,
 * and we mirror it into the same CSS variables.
 */
export function armSafeEdges(): () => void {
  return () => undefined;
}
